module.exports = __webpack_public_path__ + "static/assets/68b3e3b9a788c27ad257034e36d2a778.png";